<template>
  <header
    id="masthead"
    class="site-header"
    :class="{ 'site-header-white': !MainIndexRoute }"
  >
    <nav id="primary-navigation" class="site-navigation">
      <div class="container">
        <div class="navbar-header">
          <router-link class="site-title" to="/"
            ><span>諸葛孔明有限公司</span></router-link
          >
        </div>
        <!-- /.navbar-header -->

        <div class="collapse navbar-collapse" id="agency-navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <router-link to="/">首页</router-link>
            </li>
            <!-- <li><router-link to="/">关于我们</router-link></li> -->
            <li><router-link to="/products">产品</router-link></li>
            <li><router-link to="/contact-us">联系我们</router-link></li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- /.site-navigation -->
  </header>
  <!-- /#mastheaed -->
</template>

<script>
/* eslint-disable */
export default {
  name: "NavBar",
  data() {
    return {};
  },
  computed: {
    MainIndexRoute() {
      return this.$route.name === "Main" ? true : false;
    }
  },
  created() {
    $(document).ready(function() {
      var delay = 0,
        setTimeoutConst;
      $(
        ".site-navigation:not(.onclick) .navbar-nav>li.dropdown, .site-navigation:not(.onclick) li.dropdown>ul>li.dropdown"
      ).hover(
        function() {
          var $this = $(this);
          setTimeoutConst = setTimeout(function() {
            $this.addClass("open").slideDown();
            $this.find(".dropdown-toggle").addClass("disabled");
          }, delay);
        },
        function() {
          clearTimeout(setTimeoutConst);
          $(this).removeClass("open");
          $(this)
            .find(".dropdown-toggle")
            .removeClass("disabled");
        }
      );

      // Slicknav menu
      $(".navbar-nav").slicknav({
        allowParentLinks: true,
        label: "",
        appendTo: "#masthead",
        closedSymbol: '<i class="fa fa-caret-down" aria-hidden="true"></i>',
        openedSymbol: '<i class="fa fa-caret-up" aria-hidden="true"></i>'
      });

      // menu click event
      $(".slicknav_btn").click(function() {
        $(this).toggleClass("act");
        if ($(this).hasClass("act")) {
          $(".slicknav_menu").addClass("act");
        } else {
          $(".slicknav_menu").removeClass("act");
        }
      });
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/partials/NavBar.vue